import { Game } from "./game";
import { Controls } from "./input";
import { CONFIG } from "./config";

export interface SpaceInvadersHandle {
  moveLeft: (active: boolean) => void;
  moveRight: (active: boolean) => void;
  fire: (active: boolean) => void;
  restart: () => void;
  stop: () => void;
}

export function main(canvas: HTMLCanvasElement): SpaceInvadersHandle {
  canvas.width = CONFIG.canvas.width;
  canvas.height = CONFIG.canvas.height;
  const ctx = canvas.getContext("2d");
  if (!ctx) {
    throw new Error("space_invaders: 2D canvas context unavailable");
  }
  // Sprites are blitted from an offscreen cache, so stop the browser
  // resampling them.
  ctx.imageSmoothingEnabled = false;

  const game = new Game();
  const controls = new Controls();

  let lastTime = 0;
  let rafId = 0;
  let running = true;

  function loop(time: number): void {
    if (!running) return;
    const dt = lastTime ? Math.min((time - lastTime) / 1000, 0.05) : 0;
    lastTime = time;
    game.update(dt, controls);
    game.draw(ctx!);
    rafId = requestAnimationFrame(loop);
  }
  rafId = requestAnimationFrame(loop);

  return {
    moveLeft: (active) => {
      controls.left = active;
    },
    moveRight: (active) => {
      controls.right = active;
    },
    fire: (active) => {
      controls.fire = active;
    },
    restart: () => game.restart(),
    stop: () => {
      running = false;
      cancelAnimationFrame(rafId);
      controls.destroy();
    },
  };
}
